<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">权限测试页面</h5>
            
            <!-- 当前用户信息 -->
            <div class="row mb-4">
              <div class="col-12">
                <h6>当前用户信息：</h6>
                <div class="alert alert-info">
                  <pre>{{ JSON.stringify(userInfo, null, 2) }}</pre>
                </div>
              </div>
            </div>
            
            <!-- 权限检查结果 -->
            <div class="row mb-4">
              <div class="col-12">
                <h6>权限检查结果：</h6>
                <div class="table-responsive">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>权限</th>
                        <th>结果</th>
                        <th>说明</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>admin.view</td>
                        <td>
                          <span :class="hasAdminView ? 'badge badge-success' : 'badge badge-danger'">
                            {{ hasAdminView ? '有权限' : '无权限' }}
                          </span>
                        </td>
                        <td>查看管理员</td>
                      </tr>
                      <tr>
                        <td>permission.view</td>
                        <td>
                          <span :class="hasPermissionView ? 'badge badge-success' : 'badge badge-danger'">
                            {{ hasPermissionView ? '有权限' : '无权限' }}
                          </span>
                        </td>
                        <td>查看权限管理</td>
                      </tr>
                      <tr>
                        <td>admin.add</td>
                        <td>
                          <span :class="hasAdminAdd ? 'badge badge-success' : 'badge badge-danger'">
                            {{ hasAdminAdd ? '有权限' : '无权限' }}
                          </span>
                        </td>
                        <td>添加管理员</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            
            <!-- 测试按钮 -->
            <div class="row">
              <div class="col-12">
                <h6>测试操作：</h6>
                <button 
                  class="btn btn-primary me-2" 
                  @click="testAdminList"
                  :disabled="!hasAdminView"
                >
                  访问管理员列表
                </button>
                <button 
                  class="btn btn-success me-2" 
                  @click="testPermissionPage"
                  :disabled="!hasPermissionView"
                >
                  访问权限管理
                </button>
                <button 
                  class="btn btn-warning me-2" 
                  @click="testAddAdmin"
                  :disabled="!hasAdminAdd"
                >
                  添加管理员
                </button>
                <button 
                  class="btn btn-info" 
                  @click="refreshPermissions"
                >
                  刷新权限
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { permissionManager } from "@/utils/permission";

export default {
  page() {
    return {
      title: this.title,
      meta: [{ name: "description" }],
    };
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "权限测试",
      items: [
        {
          text: "权限测试",
          active: true,
        },
      ],
      userInfo: null,
    };
  },
  computed: {
    hasAdminView() {
      return this.$hasPermission('admin.view');
    },
    hasPermissionView() {
      return this.$hasPermission('permission.view');
    },
    hasAdminAdd() {
      return this.$hasPermission('admin.add');
    }
  },
  mounted() {
    this.loadUserInfo();
  },
  methods: {
    loadUserInfo() {
      try {
        const userStr = localStorage.getItem('user');
        if (userStr) {
          this.userInfo = JSON.parse(userStr);
        }
      } catch (error) {
        console.error('Failed to load user info:', error);
      }
    },
    testAdminList() {
      this.$router.push('/admin/list');
    },
    testPermissionPage() {
      this.$router.push('/setting/permission');
    },
    testAddAdmin() {
      this.$router.push('/admin/add');
    },
    refreshPermissions() {
      permissionManager.loadUser();
      this.loadUserInfo();
      this.$message.success('权限已刷新');
    }
  }
};
</script>

<style scoped>
.badge {
  font-size: 0.75em;
}
</style>
